import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { COLOR_GREY_2 } from "shared/theme/colors";

export const StyledTableRow = styled(TableRow)`
  cursor: pointer;

  &:hover {
    background-color: ${COLOR_GREY_2};
  }
`;
